/**
=========================================================
* PCS Admin React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the PCS Admin React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// PCS Admin React layouts
import AuthenticationSignIn from "layouts/authentication/sign-in";
import AuthenticationSignUp from "layouts/authentication/sign-up";
import Calendar from "layouts/calendar";
import Clients from "layouts/clients";
import Projects from "layouts/projects";
import Concepts from "layouts/concepts";
import ProtectedRoute from "components/ProtectedRoute";
import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import Administrators from "pages/administrators";
import AdministratorForm from "pages/administrators/form";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "route",
    name: "Login",
    key: "login",
    route: "/login",
    component: <AuthenticationSignIn />,
  },
  {
    type: "route",
    name: "Register",
    key: "register",
    route: "/register",
    component: <AuthenticationSignUp />,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Calendario",
    key: "calendar",
    icon: <Icon fontSize="small">calendar_today</Icon>,
    route: "/calendar",
    component: (
      <ProtectedRoute>
        <Calendar />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Proyectos",
    key: "projects",
    icon: <Icon fontSize="small">folder</Icon>,
    route: "/projects",
    component: (
      <ProtectedRoute>
        <Projects />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Conceptos",
    key: "concepts",
    icon: <Icon fontSize="small">folder</Icon>,
    route: "/concepts",
    component: (
      <ProtectedRoute>
        <Concepts />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Clientes",
    key: "clients",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/clients",
    component: (
      <ProtectedRoute>
        <Clients />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Administradores",
    key: "administrators",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/administrators",
    component: (
      <ProtectedRoute>
        <Administrators />
      </ProtectedRoute>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "Perfil",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: (
  //     <ProtectedRoute>
  //       <Profile />
  //     </ProtectedRoute>
  //   ),
  // },
];

// Rutas que no aparecen en el menú
export const hiddenRoutes = [
  {
    route: "/projects/:id",
    component: <Projects />,
  },
  {
    route: "/administrators/new",
    component: <AdministratorForm />,
  },
  {
    route: "/administrators/edit/:id",
    component: <AdministratorForm />,
  },
];

export default routes;
